import React from 'react';
import './/StyleComponents/HomeExperience.css';




const HomeExperience = () => {

    return (
        <div>
            <div className="HomeExperienceContainer">
                <h1 style={{marginTop:'.5em', fontSize:'2em'}}>
                    Experience
                </h1>
                <div className="PrimLogix" style={{textAlign:"left",}}>
                    <div style={{lineHeight:'.5em'}}>
                        <h1 className="RefHeader">
                            <a
                                href="https://primlogix.com/home/?_gl=1*1ywqonr*_up*MQ..*_gs*MQ..&gclid=CjwKCAiAmePKBhAfEiwAU3Ko3KqEEFdcBd_AOu0e-vnjlNtfy9bRugPmaV7kLEA_V_Tkh9MzWQq9ARoC_lUQAvD_BwE&gbraid=0AAAAAC-I22cmVoY01vi5N6hIOZGYGbuZj"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="RefHeader"
                            >
                            Prim Logix
                            </a>
                        </h1>
                        <p style={{fontSize:'.85em'}}>2024 - Present</p>
                    </div>
                    <div>
                        <div style={{lineHeight:'.5em'}}>
                        <h2>
                            FullStack development
                        </h2>
                        <p style={{fontSize:'.85em'}}>2025 - Present</p>
                    </div>
                        <p style={{fontSize:'1em'}}>
                            Developing, maintaining,
                            and supporting end-to-end features
                            across the company's web application
                        </p>
                    </div>
                    <div>
                        <div style={{lineHeight:'.5em'}}>
                            <h2>
                                Database development
                            </h2>
                            <p style={{fontSize:'.85em'}}>2024 - 2025</p>
                        </div>
                        <p style={{fontSize:'.85em'}}>
                            Designed, optimized, and maintained complex database queries,
                            views, functions, and stored procedures
                        </p>
                    </div>
                </div>
                <div className="Tutor" style={{textAlign:"left",}}>
                    <div style={{lineHeight:'.5em'}}>
                        <h1>
                            <a
                                href="https://www.successcolaire.ca/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="RefHeader"
                            >
                            Succès Scolaire
                            </a>
                        </h1>
                        <p style={{fontSize:'.85em'}}>2020 - Present</p>
                    </div>
                    <h2 className="RefHeader">
                        Tutor
                    </h2>
                    <p style={{fontSize:'1em'}}>
                        Provide 1-on-1 and small-group online tutoring to primary and secondary-level
                        students in Mathematics, Physics, Chemistry, Science, French and History
                    </p>
                </div>
            </div>
        </div>
    )
}

export default HomeExperience;